import { publicUrl } from '../config'

export type ChromeLink = {
  label: string
  href: string
  external?: boolean
}

export type SiteChrome = {
  brandSub?: string
  contactEmail?: string
  copyright?: string
  marqueeText?: string
  navLinks: ChromeLink[]
  footerColumns: Array<{ title: string; links: ChromeLink[] }>
  shopLink?: ChromeLink | null
}

export type LinktreeChrome = {
  profileLabel: string
  profileUrl: string
  footerText?: string
}

export const FALLBACK_SITE_CHROME: SiteChrome = {
  brandSub: 'Bunker-Events',
  contactEmail: 'info@bnkr.ch',
  copyright: '© BNKR Bunker Verein',
  marqueeText:
    'BNKR · BUNKER EVENTS · EVENT · LABEL · VEREIN · WEINFELDEN · CH · ON AIR · TRANSMITTING',
  navLinks: [
    { label: 'Home', href: '/' },
    { label: 'Events', href: '/events' },
    { label: 'Releases', href: '/releases' },
    { label: 'Artists', href: '/artists' },
    { label: 'Über Uns', href: '/about' },
    { label: 'Kontakt', href: '/contact' },
  ],
  footerColumns: [
    {
      title: 'Sitemap',
      links: [
        { label: 'Home', href: '/' },
        { label: 'Events', href: '/events' },
        { label: 'Releases', href: '/releases' },
        { label: 'Artists', href: '/artists' },
      ],
    },
    {
      title: 'Kontakt',
      links: [
        { label: 'Über uns', href: '/about' },
        { label: 'Kontakt', href: '/contact' },
        { label: 'FAQ', href: '/faq' },
        { label: 'info@bnkr.ch', href: 'mailto:info@bnkr.ch', external: true },
      ],
    },
    {
      title: 'Folgen',
      links: [
        { label: 'Instagram ↗', href: 'https://www.instagram.com/bnkr.ch/', external: true },
        { label: 'Soundcloud ↗', href: 'https://soundcloud.com/bnkrlabel', external: true },
        {
          label: 'Spotify ↗',
          href: 'https://open.spotify.com/user/bnkr-digital-agency',
          external: true,
        },
        { label: 'links.bnkr.ch ↗', href: 'https://links.bnkr.ch', external: true },
      ],
    },
  ],
  shopLink: {
    label: 'Shop',
    href: 'https://foursix.ch/collections/bnkr',
    external: true,
  },
}

export const FALLBACK_LINKTREE_CHROME: LinktreeChrome = {
  profileLabel: '@bnkr.ch',
  profileUrl: 'https://www.bnkr.ch',
  footerText: 'Bunker — Event und Musik-Label',
}

export function fetchSiteChrome(): Promise<{ site: SiteChrome; linktree: LinktreeChrome }> {
  return fetch(publicUrl('/site-chrome'))
    .then((r) => {
      if (!r.ok) throw new Error(`${r.status}`)
      return r.json() as Promise<{ site: SiteChrome; linktree: LinktreeChrome }>
    })
    .catch(() => ({ site: FALLBACK_SITE_CHROME, linktree: FALLBACK_LINKTREE_CHROME }))
}
